import { BaseService } from './base.service';
import { LocationDTO } from '../model/LocationDTO';
import { LocationStatsDTO } from '../model/LocationStatsDTO';
import { LocationStatsOptionsDTO } from '../model/LocationStatsOptionsDTO';
import { EnergyClassDTO } from '../model/EnergyClassDTO';

export class LocationService extends BaseService {
	async fetchLocationByCatalogNumber(catalogNumber: string): Promise<LocationDTO> {
		return await this.fetch<LocationDTO>(`/api/location/${catalogNumber}`);
	}

	async fetchLocations() {
		return await this.fetch<LocationDTO[]>('/api/location');
	}

	async fetchLocationStats(options: LocationStatsOptionsDTO = {}) {
		return await this.fetch<LocationStatsDTO[]>('/api/location/stats', {
			...options
		});
	}

	async fetchLocationStatsByCatalogNumber(catalogNumber: string, options: LocationStatsOptionsDTO = {}) {
		return await this.fetch<LocationStatsDTO>(`/api/location/${catalogNumber}/stats`, {
			...options
		});
	}

	async fetchLocationEnergyClassByCatalogNumber(catalogNumber: string) {
		return await this.fetch<EnergyClassDTO>(`/api/location/${catalogNumber}/energy-class`);
	}
}
